import "./index.css"
import { useNavigate } from "react-router-dom";
const Footer = () => {
    const navigate = useNavigate();
    return (
        <footer
            style={{
                backgroundColor: '#EE4358',
                color: 'white',
                padding: '40px 20px',
                paddingLeft: "220px",
                position: 'relative',
                bottom: 0,
                width: '100%',
            }}
            className="body3"
        >
            <div className="container">
                <div className="row">
                    {/* Logo Section */}
                    <div className="col-lg-4 col-md-12 mb-4">
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                <img
                                    src="./agarwals-4.png"
                                    alt="Agarwal's Paying Guest Logo"
                                    style={{ height: '40px', marginBottom: '10px', marginRight: "10px" }}
                                />
                                <span style={{ fontWeight: 'bold' }}>Agarwal's Paying Guest</span>
                            </div>

                        </div>
                    </div>

                    {/* Services Section */}
                    <div className="col-lg-2 col-md-4 mb-4">
                        <h5 style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '15px' }}>Our Services</h5>
                        <ul className="list-unstyled" style={{ padding: 0 }}>
                            <li>
                                <a href="#" style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                                    Safe & Secure Stay
                                </a>
                            </li>
                            <li>
                                <a href="#" style={{ color: 'white', textDecoration: 'none', fontSize: '14px', whiteSpace: "nowrap" }}>
                                    Hygienic & Comfortable Rooms
                                </a>
                            </li>
                            <li>
                                <a href="#" style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                                    Delicious & Healthy Meals
                                </a>
                            </li>
                            <li>
                                <a href="#" style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                                    Amenities: Wi-Fi, Lift, Power Backup
                                </a>
                            </li>
                            <li>
                                <a href="#" style={{ color: 'white', textDecoration: 'none', fontSize: '14px' }}>
                                    CCTV & Security Monitoring
                                </a>
                            </li>
                        </ul>
                    </div>


                    {/* Know More Section */}
                    <div className="col-lg-2 col-md-4 mb-4">
                        <h5 style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '15px', textAlign: "left" }}>Know More</h5>
                        <ul className="list-unstyled" style={{ padding: 0 }}>
                            <li><p onClick={() => navigate("/aboutUs")} style={{ color: 'white', textDecoration: 'none', fontSize: '14px', textAlign: "left", cursor: "pointer" }}> About Us</p></li>
                            <li><p onClick={() => navigate("/contactUs")} style={{ color: 'white', textDecoration: 'none', fontSize: '14px', textAlign: "left", cursor: "pointer" }}>Careers</p></li>
                            <li><p style={{ color: 'white', textDecoration: 'none', fontSize: '14px', textAlign: "left" }}>Privacy Policy</p></li>
                        </ul>
                    </div>

                    {/* Contact Section */}
                    <div className="col-lg-4 col-md-4 mb-4">
                        <h5 style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '15px', cursor: "pointer" }} onClick={() => navigate("/contactUs")}>Say Hello!</h5>
                        <p style={{ fontSize: '14px', marginBottom: '30px', textAlign: "left" }}>
                            <a href="mailto:agarwalspayingguest@gmail.com" style={{ color: 'white', textDecoration: 'none' }}>
                                agarwalspayingguest@gmail.com
                            </a>
                        </p>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="row mt-4">
                    <div className="col footer-last-row" style={{ gap: "30px" }}>
                        <p style={{ fontSize: '14px', margin: 0 }}>© Copyright 2025 | Designed & Developed by Agarwal's Paying Guest | All Right Reserved</p>
                        <div style={{ display: 'flex', gap: '10px', marginRight: "20%" }}>

                            <a href="https://www.instagram.com/agarwals_paying_guest_?igsh=eGdhcjZidzV6OW5j&utm_source=qr" target={"_blank"} style={{ color: 'white', fontSize: '20px' }}>
                                <img className="bi bi-linkedin" src="./insta.png" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>

        </footer >
    );
};

export default Footer;
